import api from './base'

export default {
  getAll ({ businessUnitId }) {
    return api().get(`company/business_units/${businessUnitId}/print_locations`)
  },
  getById ({ businessUnitId, id }) {
    return api().get(`company/business_units/${businessUnitId}/print_locations/${id}`)
  },
  save ({ businessUnitId, item }) {
    return api().put(`company/business_units/${businessUnitId}/print_locations`, item)
  },
  delete ({ businessUnitId, id }) {
    return api().delete(`company/business_units/${businessUnitId}/print_locations/${id}`)
  },
  setCategoryLocations ({ businessUnitId, categoryId, LocationId }) {
    return api().put(`company/business_units/${businessUnitId}/categories/${categoryId}/print_locations`, LocationId)
  },
  getCategoryLocations ({ businessUnitId, categoryId }) {
    return api().get(`company/business_units/${businessUnitId}/categories/${categoryId}/print_locations`)
  },
  deleteCategoryLocations ({ businessUnitId, categoryId, LocationId }) {
    return api().delete(`company/business_units/${businessUnitId}/categories/${categoryId}/print_locations/${LocationId}`)
  }
}
